
    <!-- <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div> -->

    <h3>You got {{ freeSpins }} Free spins</h3>
    <img src="/assets/images/v2/free-spins-coins.svg" height="150" class="free-spins-claim-img" />
    <!-- <div class="div-block-4"> -->
    <!-- <img src="/assets/images/v2/free-spins-icon-bar.svg" width="40" class="free-spins-popup-icon" /> -->
    <!-- <h4 class="no-margin">{{ freeSpins }} Free spins</h4> -->
    <!-- </div> -->
    <app-form-button class="default" (click)="close()">Claim free spins</app-form-button>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/free-spins-modal.component.ts.ModalFreeSpinsComponent.html